// possible values for default Input types.
export enum InputTypes {
  TEXT = 'text',
  EMAIL = 'email',
  PASSWORD = 'password',
  NUMBER = 'number',
}

// possible values for default Input width
export enum InputWidthValues {
  SMALL = '80',
  XSMALL = '120',
  MEDIUM = '160',
  LARGE = '240',
  XLARGE = '320',
  XXLARGE = '400',
  FULL = 'full',
}

export enum InputEvents {
  CHANGE = 'change',
  BLUR = 'blur',
  DELETE = 'delete',
  SEARCH = 'search',
}
